/**
 * @param {import('./documentPreviewTypes.js').GeneratedArtifactPreview} artifact
 * @returns {string}
 */

export function getArtifactExportText(artifact) {
  const { kind, payload } = artifact

  if (kind === 'doc') {
    const docPayload = /** @type {import('./documentPreviewTypes.js').DocPreviewPayload} */ (payload)
    if (typeof docPayload.markdown === 'string' && docPayload.markdown.trim()) {
      return docPayload.markdown
    }
    if (Array.isArray(docPayload.sections)) {
      return docPayload.sections
        .map((section) => {
          if (section.type === 'heading') {
            const hashes = '#'.repeat(Math.min(6, Math.max(1, section.level ?? 2)))
            return `${hashes} ${section.text}`
          }
          return section.text
        })
        .join('\n\n')
    }
  }

  if (kind === 'html') {
    return /** @type {import('./documentPreviewTypes.js').HtmlPreviewPayload} */ (payload).html ?? ''
  }

  if (kind === 'spreadsheet') {
    const sheet = /** @type {import('./documentPreviewTypes.js').SpreadsheetPreviewPayload} */ (payload)
    const header = sheet.columns?.join(',') ?? ''
    const rows =
      sheet.rows?.map((row) => sheet.columns.map((col) => String(row[col] ?? '')).join(',')).join('\n') ?? ''
    return [header, rows].filter(Boolean).join('\n')
  }

  return ''
}

/**
 * @param {string} fileName
 * @param {import('./documentPreviewTypes.js').ArtifactKind} kind
 */
